import { State } from '../state';
import { EmployeesModState } from './state';
import { getStoreAccessors } from "typesafe-vuex";


export const getters = {
    employees: (state: EmployeesModState) => state.employees,
    employeeRoles: (state: EmployeesModState) => state.employeeRoles,
    
};

export const { read } = getStoreAccessors<EmployeesModState, State>('');

export const readEmployees = read(getters.employees);
export const readRoles = read(getters.employeeRoles);

